// extracted by mini-css-extract-plugin
export var container = "_ds-0";
export var content = "_ds-3";
export var customerTitle = "_ds-4";
export var empty = "_ds-5";
export var gray = "_ds-6";
export var header = "_ds-7";
export var info = "_ds-8";
export var loading = "_ds-2";
export var loadingCard = "_ds-9";
export var oneLine = "_ds-a";
export var personName = "_ds-e";
export var pillContainer = "_ds-b";
export var selected = "_ds-1";
export var text = "_ds-c";
export var twoLines = "_ds-d";
export var unread = "_ds-f";
export var unreadIndicator = "_ds-g";